var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 10",
    style: {
      enableBackground: "new 0 0 40 10"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#BA3A0B;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.5,9.5c3.6,0,6.5-2,6.5-4.5s-2.9-4.5-6.5-4.5c-3.4,0-6.2,1.8-6.5,4.1h-4.7V3.7H0v2.7h22.4V5.4H27 C27.3,7.7,30.1,9.5,33.5,9.5z M21.5,5.5H0.9V4.5h20.6V5.5z M27.9,5c0-2,2.5-3.7,5.6-3.7S39.1,3,39.1,5c0,2-2.5,3.7-5.6,3.7 S27.9,7,27.9,5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpoon);
export default __webpack_public_path__ + "static/media/spoon.1c3be3d2e93f872f7e453ce8f850b391.svg";
export { ForwardRef as ReactComponent };